export function setRenderedAppState(isAppRendered = true) {
  return (dispatch) => {
    dispatch({
      type: 'SET_RENDERED_APP_STATE',
      payload: {
        isAppRendered
      }
    })
  }
}

export function setDropdownVisibility(dropdownsVisibility) {
  return (dispatch) => {
    dispatch({
      type: 'SET_DROPDOWNS_VISIBILITY',
      payload: {
        dropdownsVisibility,
      }
    })
  }
}

export function setAppActionsDisabledState(areAppActionsDisabled) {
  return (dispatch) => {
    dispatch({
      type: 'SET_APP_ACTIONS_DISABLED_STATE',
      payload: {
        areAppActionsDisabled,
      }
    })
  }
}
